import { NavItem } from '../../nav/primitives/nav-item';
import { useMessagesNavItem } from './use-messages-nav-item';

export const MessagesNavItem = () => {
  const item = useMessagesNavItem();
  return <NavItem item={item} />;
};
